export enum Navigation {
  TURNTABLE = 'turntable',
  GALLERY = 'gallery',
}

export enum Direction {
  NEXT = 'next',
  PREVIOUS = 'previous',
}
